import { RevokeParkingRight } from "../models/RevokeParkingRight";
import { DelegatedParkingProducts, Delegee } from "../store/reducers/parking-products";

export function getRegistrationIdByParkingRightId(parkingRightId: string, 
    delegatedParkingProducts: DelegatedParkingProducts, 
    delegees: Delegee ): RevokeParkingRight {
    if(delegatedParkingProducts.pages){
        const countPages = delegatedParkingProducts.totalPages;
        for (let i = 1; i <= countPages; i++) {
            const page = delegatedParkingProducts.pages[i];
            if(page){
                const delegatedParkingRight = page.data!.find(x => x.parkingRight.parkingRightId === parkingRightId);
                if(delegatedParkingRight ){
                    const model: RevokeParkingRight = {
                        parkingRightId: delegatedParkingRight.parkingRight.parkingRightId,
                        registrationId: delegatedParkingRight.delegee.registrationId,
                    }

                    return model;
                }
            }
        }
    }

    if(delegees.pages){
        const countPages = delegees.totalPages;
        for (let i = 1; i <= countPages; i++) {
            const page = delegees.pages[i];
            if(page){
                const delegee = page.data!.find(x => x.products.find(p => p.parkingRightId === parkingRightId));
                if(delegee){
                    const model: RevokeParkingRight = {
                        parkingRightId: parkingRightId,
                        registrationId: delegee.registrationId,
                    }

                    return model;
                }
            }
        }
    }
    
    const model: RevokeParkingRight = {
        parkingRightId: parkingRightId,
        registrationId: '',
    }

    return model;
}